import {
  dateSlashFormat,
  getDateFormatMMYYYY,
} from "../../utils/helpers/dateFormatter";
import { getFundCertificateNumber } from "../../utils/helpers/getFundCertificateNumber";
import { getFundLabel } from "../../utils/helpers/getFundLabel";
import DepositStatusIcon from "./DepositStatusIcon/DepositStatusIcon";

export const fixedTwoDigitsNumber = (num) => {
  return (Math.round(num * 100) / 100).toFixed(2);
};

export function makeInnerDepositData(deposit, mobileRender) {
  if (deposit) {
    const depositData = [
      {
        depEmployeeSum: deposit.depEmployeeSum
          ? fixedTwoDigitsNumber(deposit.depEmployeeSum)
          : 0,
        depEmployerSum: deposit.depEmployerSum
          ? fixedTwoDigitsNumber(deposit.depEmployerSum)
          : 0,
        depCompensationSum: deposit.depCompensationSum
          ? fixedTwoDigitsNumber(deposit.depCompensationSum)
          : 0,
        depDifferentSum: deposit.depDifferentSum
          ? fixedTwoDigitsNumber(deposit.depDifferentSum)
          : 0,
        tranEmployeeSum: deposit.tranEmployeeSum
          ? fixedTwoDigitsNumber(deposit.tranEmployeeSum)
          : 0,
        tranEmployerSum: deposit.tranEmployerSum
          ? fixedTwoDigitsNumber(deposit.tranEmployerSum)
          : 0,
        tranCompensationSum: deposit.tranCompensationSum
          ? fixedTwoDigitsNumber(deposit.tranCompensationSum)
          : 0,
        tranDifferentSum: deposit.tranDifferentSum
          ? fixedTwoDigitsNumber(deposit.tranDifferentSum)
          : 0,
      },
    ];

    if (mobileRender) return depositData[0];
    return depositData;
  }
  return [];
}

export function makeDepositData(depositsList,funds) {

  if (depositsList?.length) {
    return depositsList.map((deposit, index) => {
      return {
        id: index,
        kopatGemel: getFundLabel(deposit.fundCode),
        // localStorage.getItem('lang') === "he" ? funds.find((item)=>(item.fundID ===deposit.fundCode)).fundNameHeb:
        // funds.find((item)=>(item.fundID ===deposit.fundCode)).fundNameArabic        ,
        employerName: deposit.factoryName,
        salaryMonth: getDateFormatMMYYYY(deposit.salaryDate),
        depositDate: dateSlashFormat(deposit.depositDate),
        sum: fixedTwoDigitsNumber(
          deposit.depCompensationSum +
            deposit.depEmployeeSum +
            deposit.depEmployerSum +
            deposit.depDifferentSum
        ),
        status: (
          <DepositStatusIcon
            isDepositOk={
              deposit.fullyAscribed 
            }
          />
        ),
        subRows: [true],
      };
    });
  }
  return [];
}

export function makeSepTableData(transactionsList) {
  if (transactionsList?.length) {
    return transactionsList.map((transaction) => {
      return {
        kopatGemel:getFundLabel(transaction.fundCode),
        //transaction.fundNameHeb, // localStorage.getItem('lang') === "he" ? transaction.fundNameHeb:transaction.fundNameArab,
        employerName: transaction.factoryName,
        salaryMonth: getDateFormatMMYYYY(transaction.monthFrom),
        depositDate: dateSlashFormat(transaction.dateValue),
        sum: fixedTwoDigitsNumber(
          transaction.employeeSum +
            transaction.employerSum +
            transaction.compensation
        ),
        employeeAwards: fixedTwoDigitsNumber(transaction.employeeSum),
        employerAwards: fixedTwoDigitsNumber(transaction.employerSum),
        awards: fixedTwoDigitsNumber(transaction.compensation),
        depositType: transaction.programDescription
          ? transaction.programDescription.trim()
          : "",
      };
    });
  }
  return [];
}

export function makeExcelDepositData(depositsList, userFullName,fullyAscribedYes,fullyAscribedNo) {
  if (depositsList?.length && userFullName?.length) {
    const excelData = depositsList.map((deposit) => {
      return [
        userFullName,
        deposit.memberId,
        localStorage.getItem('lang') === "he" ? deposit.fundNameHeb:deposit.fundNameArab,          
        // deposit.fCertNumber,
        deposit.factoryName,
        dateSlashFormat(deposit.depositDate),
        getDateFormatMMYYYY(deposit.salaryDate),
        deposit.depEmployeeSum
          ? +fixedTwoDigitsNumber(deposit.depEmployeeSum)
          : 0,
        deposit.depEmployerSum
          ? +fixedTwoDigitsNumber(deposit.depEmployerSum)
          : 0,
        deposit.depCompensationSum
          ? +fixedTwoDigitsNumber(deposit.depCompensationSum)
          : 0,
        "",
        deposit.depDifferentSum
          ? +fixedTwoDigitsNumber(deposit.depDifferentSum)
          : 0,
        deposit.tranEmployeeSum
          ? +fixedTwoDigitsNumber(deposit.tranEmployeeSum)
          : 0,
        deposit.tranEmployerSum
          ? +fixedTwoDigitsNumber(deposit.tranEmployerSum)
          : 0,
        deposit.tranCompensationSum
          ? +fixedTwoDigitsNumber(deposit.tranCompensationSum)
          : 0,
        "",
        deposit.tranDifferentSum
          ? +fixedTwoDigitsNumber(deposit.tranDifferentSum)
          : 0,
        deposit.fullyAscribed ? fullyAscribedYes : fullyAscribedNo,  
      ];
    });

    return excelData;
  }
  return [];
}

export function makeExcelSepData(transactionsList, userFullName) {
  if (transactionsList?.length) {
    const excelData = transactionsList.map((transaction) => {
      return [
        userFullName,
        transaction.memberId,
        localStorage.getItem('lang') === "he" ? transaction.fundNameHeb:transaction.fundNameArab,      
        // transaction.fundCertNumber,
        transaction.factoryName,
        dateSlashFormat(transaction.monthFrom),
        getDateFormatMMYYYY(transaction.dateValue),
        +fixedTwoDigitsNumber(
          transaction.employeeSum +
            transaction.employerSum +
            transaction.compensation
        ),
        +fixedTwoDigitsNumber(transaction.employeeSum),
        +fixedTwoDigitsNumber(transaction.employerSum),
        +fixedTwoDigitsNumber(transaction.compensation),
        transaction.programDescription
          ? transaction.programDescription.trim()
          : "",
      ];
    });
    return excelData;
  }
  return [];
}
